import { useQuery } from '@tanstack/react-query';
import { shopifyApi } from '@/api/shopify.api';
import type { ShopifyStore } from '@/types/api';

/**
 * Authoritative list of stores comes from the backend.
 * The Shopify stores endpoint returns only active stores, ordered by code.
 */
export function useStores() {
  return useQuery<ShopifyStore[]>({
    queryKey: ['shopify', 'stores'],
    queryFn: () => shopifyApi.listStores(),
    staleTime: 5 * 60 * 1000
  });
}
